/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedOrderRejectRequest } from '../types/PatchedOrderReject';
import type { OrderRejectResponse } from '../types/OrderReject';

export type OrdersRejectPartialUpdateRequest = PatchedOrderRejectRequest;
export type OrdersRejectPartialUpdateResponse = OrderRejectResponse;

export type OrdersRejectPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/orders/{id}/reject/
 *
 * ```yaml
 * operationId: orders_reject_partial_update
 * description: |-
 *   {"rejection_reason": "…"} — zamítne žádost ve stavu FAILED.
 *
 *   Verdikt jde do IS DMVS synchronně; nepotvrzený verdikt shodí request 502
 *   (rollback) — žádost zůstane ve FAILED a admin akci zopakuje.
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderReject'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderReject'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderReject'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderReject'
 *     description: ''
 * ```
 */
export const ordersRejectPartialUpdateOperation = ({
  id,
  ...rest
}: OrdersRejectPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/orders/${id}/reject/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/orders/{id}/reject/' };
  };

/**
 * PATCH /dmx-server/orders/{id}/reject/
 *
 * ```yaml
 * operationId: orders_reject_partial_update
 * description: |-
 *   {"rejection_reason": "…"} — zamítne žádost ve stavu FAILED.
 *
 *   Verdikt jde do IS DMVS synchronně; nepotvrzený verdikt shodí request 502
 *   (rollback) — žádost zůstane ve FAILED a admin akci zopakuje.
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderReject'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderReject'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderReject'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderReject'
 *     description: ''
 * ```
 */
export const ordersRejectPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: OrdersRejectPartialUpdateQuery;
  request: PatchedOrderRejectRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<OrderRejectResponse>> => {
  const operation = ordersRejectPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
